import React from 'react';
import { Drawer } from '@dnb/eufemia';

export interface Props {
  breadcrumb?: React.ReactNode;
  header: React.ReactNode;
  content: React.ReactNode;
  onClose: () => void;
}

const DrawerPageLayout = ({ header, breadcrumb, onClose, content }: Props) => {
  function onDrawerClose({ close }: { close: () => void }) {
    close();
    setTimeout(onClose, 100);
  }

  return (
    <Drawer
      data-testid="drawer"
      openState="opened"
      triggerAttributes={{ hidden: true }}
      preventClose={true}
      onClosePrevent={onDrawerClose}
      closeButtonAttributes={{ 'data-testid': 'drawer-close-button' }}
    >
      <Drawer.Navigation data-testid="breadcrumb">
        {breadcrumb}
      </Drawer.Navigation>
      <Drawer.Header data-testid="header">{header}</Drawer.Header>
      <Drawer.Body data-testid="content" spacing="large">
        {content}
      </Drawer.Body>
    </Drawer>
  );
};

export default DrawerPageLayout;
